import React from 'react';
import PropTypes from 'prop-types';
import Picture from '../Picture';
import { PICTURE_VARIANTS } from '../constants';
import DefaultPic from '../../icons/defaultProfilePicture.png';
import Globe from '../../icons/globe-emoji.png';
import './styles.scss';

function Banner({ greeting, heading, message, image, greetingImage }) {
    return (
        <div className="titleWrapper">
            <div className="welcome d-flex d-row align-items-center">
                <img src={greetingImage} alt="hello" className="welcomeImage" />
                <div className="d-flex align-items-center">
                    <h2>{greeting}</h2>
                    <Picture
                        source={image}
                        variant={PICTURE_VARIANTS.VARIANT_XS}
                    />
                    <h2>{heading}</h2>
                </div>
            </div>
            <p>{message}</p>
        </div>
    );
}

Banner.propTypes = {
    greeting: PropTypes.string,
    heading: PropTypes.string,
    message: PropTypes.string,
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    greetingImage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

Banner.defaultProps = {
    greeting: 'Hello,  ',
    heading: 'World Wild Fund',
    message: `You're currently viewing your totals from all challenges world-wide.`,
    image: DefaultPic,
    greetingImage: Globe,
};

export default Banner;
